var n=function(n){var r=n.icon;return r||null};export{n as ButtonIconRenderer};
